import { render, staticRenderFns } from "./SaveToTemplate.vue?vue&type=template&id=99ecf0e4&scoped=true&"
import script from "./SaveToTemplate.vue?vue&type=script&lang=js&"
export * from "./SaveToTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SaveToTemplate.vue?vue&type=style&index=0&id=99ecf0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ecf0e4",
  null
  
)

export default component.exports